export default __webpack_public_path__ + "static/media/papayapay_new_logo.8abea9b7.png";